@let gridData = $gridData();
@let T = gridData.data;
<unity-grid-shared
  gridTitle=""
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="reference_number_display" title="Client Id">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared
        [displayText]="item.reference_number_display"
        [link]="['/agreement', $agreementId(), 'client', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="first_name" title="First Name" />
  <kendo-grid-column field="last_name" title="Last Name" />
  <kendo-grid-column field="remaining_allocated_amount" title="Remaining Allocated Amount" filter="numeric">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-gridcell-currency-shared [value]="item.remaining_allocated_amount" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
